import type { OnboardingPlacement } from './WorkbenchOnboarding'

// First-run tour: informative only — the overlay blocks every click and the
// user pages through with Next. Each step rings its target(s) and explains
// the feature; nothing here mutates workbench state.
//
// Targets are plain selectors matched against the live DOM and a miss is silent
// (flat dim, centred card, no ring), so a step pointing at a rail tool must
// track that tool's `id` in RAIL_TOOLS — renaming one there unrings it here.
// Its own module so the test can assert that without Workbench.tsx exporting
// non-components (react-refresh).
export const ONB_STEPS: { targets: string[]; placement: OnboardingPlacement; copy: string }[] = [
  {
    targets: ['[data-tool="buy"]', '[data-tool="sell"]'],
    placement: 'right',
    copy: "Click Buy or Sell and then draw your entry, stop loss and take profit on the chart. AI will use everything on your chart as context to automate your strategy.",
  },
  {
    targets: ['#symbol-search-btn'],
    placement: 'bottom',
    copy: 'Change markets here. We will auto-save drawings, markers and annotations so nothing will be lost.',
  },
  {
    targets: ['#indicators-btn'],
    placement: 'bottom',
    copy: 'Add indicators like RSI or moving averages to the chart. The AI sees them too and can build your entry and exit rules around them.',
  },
  {
    targets: ['#chat-composer'],
    placement: 'left',
    copy: "AI will use all your context (written, visuals and data) to automate your strategy. Leave 'Chart context' ticked and every change you make here is shared automatically.",
  },
]
